<nb-card>
  <nb-card-header>
    <h3>Room Dashboard </h3>
    <div class="row" *ngIf="this.showFilter">
      <div class="col-12">
        <kw-filter-dropdown (filterResultsChange)="search($event)"
          [filterSettings]="this.filterSettings"></kw-filter-dropdown>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="this.isLoading">
    <div class="row" *ngIf="!this.isLoading">
      <!-- <div class="col-lg-4 col-12">
      </div> -->
      <div class="col-lg-12 col-12">
        <h5>Current Inventory</h5>
        <ejs-grid #inventoryGrid id="inventoryGrid" [dataSource]="this.inventorySummaries" [enableStickyHeader]='true'
          [filterSettings]='this.ejsConstants.filterSettings' [columns]="this.inventoryColumns" [allowPaging]="true" rowHeight="38"
          [textWrapSettings]="this.ejsConstants.textWrapSettings" [allowTextWrap]="true" [pageSettings]="this.ejsConstants.pageSettings"
          [allowFiltering]="true" [allowSorting]='true' [allowResizing]="true" [detailTemplate]="this.detailTemplate"></ejs-grid>

      </div>
      <div class="col-lg-12 col-12">
        <h5>Room Log</h5>
        <ejs-grid #logGrid id="logGrid" [dataSource]="this.room.roomLogs" [enableStickyHeader]='true' rowHeight="38"
          [filterSettings]='this.ejsConstants.filterSettings' [columns]="this.logColumns" [allowPaging]="true"
          [textWrapSettings]="this.ejsConstants.textWrapSettings" [allowTextWrap]="true" [pageSettings]="this.ejsConstants.pageSettings"
          [allowFiltering]="true" [allowSorting]='true' [allowResizing]="true"></ejs-grid>
    
      </div>
    </div>
    
  </nb-card-body>
</nb-card>

<ng-template #detailTemplate let-data>
  <div style="max-width: 80vw;">
      <lot-details-by-room [roomId]="this.roomId" [varietyId]="data.varietyId" [blockId]="data.blockId" [farmId]="data.farmId"
      (refreshTable)="refreshParentTable($event)"></lot-details-by-room>

  </div>

</ng-template>
<ng-template #logDateTemplate let-data>
  {{data.timeCreated | date: 'mediumDate'}}
</ng-template>

<ng-template #viewLots let-data>
  <button mat-icon-button (click)="viewLotsClicked(data);">
    <fa-icon size="lg" [icon]="faBars"></fa-icon>
  </button>
</ng-template>